/**
 * 관리자 페이지 카테고리별 하위 탭 정의.
 *
 * 사이드바는 `/admin?category=XXX&tab=yyy`로 진입한다. 카테고리가 여기에 없으면
 * 탭 줄이 렌더되지 않고 본문도 비어 사용자에게는 "메뉴가 죽은" 화면으로 보인다.
 * if 체인으로 흩어두면 카테고리를 추가할 때 한쪽을 빠뜨리기 쉬워 한곳에 모았다.
 */

export interface AdminTab {
  id: string;
  label: string;
}

export const ADMIN_TABS: Record<string, AdminTab[]> = {
  DLP: [
    { id: 'dlp-report', label: 'DLP 운영보고서 관리' },
    { id: 'dlp-license', label: 'DLP 라이센스 관리' },
  ],
  NAC: [{ id: 'nac-report', label: 'NAC 운영보고서 관리' }],
  WEB_FILTER: [
    { id: 'wf-report', label: '유해차단 운영보고서 관리' },
    { id: 'wf-traffic-upload', label: '트래픽 데이터 업로드' },
    { id: 'wf-non-business-upload', label: '비업무사이트 업로드' },
  ],
  EXCEPTION: [
    { id: 'exception-security', label: '보안 예외처리' },
    { id: 'exception-dlp', label: 'DLP 예외처리' },
    { id: 'exception-nac', label: 'NAC 예외처리' },
    { id: 'exception-wf', label: '유해차단 예외처리' },
    { id: 'exception-actor', label: '처리자 관리' },
  ],
  EDR: [
    { id: 'edr-html', label: '위협탐지 HTML 등록' },
    { id: 'edr-report', label: 'EDR 운영보고서 관리' },
    { id: 'edr-license', label: 'EDR 라이선스 관리' },
  ],
};

/** 탭 줄을 그릴 카테고리인지 */
export const hasTabs = (category: string): boolean => Boolean(ADMIN_TABS[category]?.length);

/**
 * URL의 `tab`을 그 카테고리의 유효한 탭으로 해석한다.
 *
 * 다른 카테고리의 tab이 URL에 남아 있는 경우(카테고리만 바꿔 이동)에도
 * 첫 탭으로 교정한다 — 그대로 두면 어떤 패널도 조건에 걸리지 않아 본문이 사라진다.
 */
export const resolveActiveTab = (category: string, tab: string): string => {
  const tabs = ADMIN_TABS[category];
  if (!tabs || tabs.length === 0) return '';

  return tabs.some((t) => t.id === tab) ? tab : tabs[0].id;
};
